import swal from "sweetalert2";
import AdminApi from "../../services/api";
import session from "../../services/session";


const AdminApiService = new AdminApi()


const mapPackage = require('../../assets/img/pin1.png');
const mapPackagePick = require('../../assets/img/pin2.png');
const mapCourier = require('../../assets/img/icon_courier.png');
const mapPackageTo = require('../../assets/img/icon_package.png');

export default {
    data() {
        return {
            filter: '',
            orderId: '',
            windowHeight: window.innerHeight,
            windowWidth: window.innerWidth,
            markerOptions: {
                url: mapPackage,
                size: {width: 60, height: 60, f: 'px', b: 'px',},
                scaledSize: {width: 30, height: 30, f: 'px', b: 'px',},
                labelOrigin: {x: 15, y: 37}
            },
            markerOptionsPicked: {
                url: mapPackagePick,
                size: {width: 60, height: 60, f: 'px', b: 'px',},
                scaledSize: {width: 30, height: 30, f: 'px', b: 'px',},
                labelOrigin: {x: 15, y: 37}
            },
            markerOptionsCourier: {
                url: mapCourier,
                size: {width: 60, height: 60, f: 'px', b: 'px',},
                scaledSize: {width: 30, height: 30, f: 'px', b: 'px',},
                labelOrigin: {x: 15, y: 37}
            },
            markerPackageTo: {
                url: mapPackageTo,
                size: {width: 60, height: 60, f: 'px', b: 'px',},
                scaledSize: {width: 30, height: 30, f: 'px', b: 'px',},
                labelOrigin: {x: 15, y: 37}
            },
            center: {
                lat: 45.2409968,
                lng: 19.806445
            },
            orders: [],
            drivers: [],
            couriersActiveCount: new Map(),
            locationMarkers: [],
            locPlaces: [],
            existingPlace: null,
            calledFunc: null,
            calledFuncDrivers: null,
            options: {
                styles: [
                    {
                        "featureType": "administrative",
                        "elementType": "labels.text.fill",
                        "stylers": [
                            {

                                "color": "#d4d4d4",
                                // "color": "#444444",
                            }
                        ]
                    },
                    {
                        "featureType": "landscape",
                        "elementType": "all",
                        "stylers": [
                            {
                                "color": "#f2f2f2"
                            }
                        ]
                    },
                    {
                        "featureType": "poi",
                        "elementType": "all",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "road",
                        "elementType": "all",
                        "stylers": [
                            {
                                "saturation": -100
                            },
                            {
                                "lightness": 45
                            }
                        ]
                    },
                    {
                        "featureType": "road.highway",
                        "elementType": "all",
                        "stylers": [
                            {
                                "visibility": "simplified"
                            }
                        ]
                    },
                    {
                        "featureType": "road.arterial",
                        "elementType": "labels.icon",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "transit",
                        "elementType": "all",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "water",
                        "elementType": "all",
                        "stylers": [
                            {
                                "color": "#46bcec"
                            },
                            {
                                "visibility": "on"
                            }
                        ]
                    }
                ]
            }
        }
    },
    mounted() {
        this.locateGeoLocation();
    },

    beforeMount() {
        this.orderId = this.$route.query.orderId;
        // this.startFetchOrders();
        // this.startFetchDrivers();
    },
    created(){
        this.$tabEvent.on('onNewOrder', (data) => {
            this.getOrders();
        });
    },
    beforeDestroy() {
        if(this.calledFunc != null){
            clearTimeout(this.calledFunc);
            this.calledFunc = null;
        }
        if(this.calledFuncDrivers != null){
            clearTimeout(this.calledFuncDrivers);
            this.calledFuncDrivers = null;
        }
    },
    methods: {
        startFetchOrders: startFetchOrders,
        startFetchDrivers: startFetchDrivers,
        generateCouriersCount: generateCouriersCount,
        getOrders: getOrders,
        visibleDevelop: visibleDevelop,
        generateMarkers: generateMarkers,
        myStyle(){
            return ' width: 100%; height: 800px' + this.windowHeight;
        },

        initMarker(loc) {
            this.existingPlace = loc;
        },

        addLocationMarker() {
            if (this.existingPlace) {
                const marker = {
                    lat: this.existingPlace.geometry.location.lat(),
                    lng: this.existingPlace.geometry.location.lng()
                };
                this.locationMarkers.push({ position: marker });
                this.locPlaces.push(this.existingPlace);
                this.center = marker;
                this.existingPlace = null;
            }
        },
        locateGeoLocation: function() {
            navigator.geolocation.getCurrentPosition(res => {
                this.center = {
                    lat: res.coords.latitude,
                    lng: res.coords.longitude
                };
            });
        }
    }
}

function startFetchDrivers(){
    this.getDrivers();

    // this.getOrders();
    let _self = this;
    if(_self.calledFuncDrivers != null){
        clearTimeout(_self.calledFuncDrivers);
    }
    _self.calledFuncDrivers = setTimeout(function(){ _self.startFetchDrivers(); }, 7000);
}

function startFetchOrders() {
    // this.getDrivers();
    this.getOrders();
    let _self = this;
    if(_self.calledFunc != null){
        clearTimeout(_self.calledFunc);
    }
    _self.calledFunc = setTimeout(function(){ _self.startFetchOrders(); }, 12000);
}

function getOrders() {
    var _self = this;
    // var activeParams = "?status=INITIAL&status=ACCEPTED&status=DECLINED&status=ASSIGNED&status=PICKED_UP"; TODO skariti pokupljene, jer su pokupljeni
    AdminApiService.getOrderIntegration(this.orderId)
        .then((response) => {
            var ords = [];
            ords.push(response.data)
            _self.orders = ords;
            // _self.orders = response.data.filter(item => item.status === "INITIAL" || item.status === "REQUESTED" || item.status === "ACCEPTED" || item.status === "DECLINED" || item.status === "ASSIGNED" || item.status === "APPROVED");
            _self.generateMarkers();
            _self.generateCouriersCount(response.data);
        })
        .catch((error) => {
            swal('Greška', error.data.message, 'error')
        })
}
//
// function getDrivers() {
//     var _self = this;
//     var activeParams = "?active=true";
//     AdminApiService.getDrivers(activeParams)
//         .then((response) => {
//             _self.drivers = [];
//             _self.drivers = response.data.map(e => {
//                 let activeOrders = _self.couriersActiveCount.get(e.id) != null ? _self.couriersActiveCount.get(e.id) : 0;
//                 return {
//                     id: e.id,
//                     name: e.lastName,
//                     active: e.active,
//                     activeOrders: activeOrders,
//                     lat: e.position != null ? e.position.lat : null,
//                     lng: e.position != null ? e.position.lng : null
//                 }
//             });
//             _self.generateMarkers();
//         })
//         .catch((error) => {
//             swal('Greška', error.data, 'error')
//         })
// }

function generateMarkers() {
    let _self = this;
    this.locationMarkers  = [];

    var ords = this.orders.filter(item => { return item.company.name.toLowerCase().indexOf(this.filter.toLowerCase().trim()) > -1 });
    let samePlaces = new Map();
    for (let i = 0; i < ords.length; i++) {
        if(samePlaces.get(ords[i].company.name) == null){
            samePlaces.set(ords[i].company.name, 1)
        }else{
            let newValue = samePlaces.get(ords[i].company.name) + 1;
            samePlaces.set(ords[i].company.name, newValue)
        }
    }

    for (let i = 0; i < ords.length; i++) {
        const marker = {
            lat: +ords[i].company.address.lat,
            lng: +ords[i].company.address.lng,

        };

        let isPicked = ords[i].status === "PICKED_UP";

        let desc = {
            text: ords[i].company.name + " [" + samePlaces.get(ords[i].company.name) + "]",
            color: isPicked ? '#fdbe2b' : 'black',
            fontWeight: 'bold',
            fontSize: '14px'
        };

        this.locationMarkers.push({ position: marker, icon: isPicked ? _self.markerOptionsPicked : _self.markerOptions, desc: desc });

        if(_self.visibleDevelop()){
            const markerTo = {
                lat: +ords[i].address.lat,
                lng: +ords[i].address.lng,

            };

            let descTo = {
                text: ords[i].company.name + ' - '+ ords[i].company.id,
                color: 'black',
                fontWeight: 'bold',
                fontSize: '14px'
            };

            this.locationMarkers.push({ position: markerTo, icon: _self.markerPackageTo , desc: descTo });

        }
    }
    var drivers = this.drivers;
    for (let i = 0; i < drivers.length; i++) {
        if(drivers[i].active && drivers[i].lat !== null &&  drivers[i].lng !== null){
            const marker = {
                lat: +drivers[i].lat,
                lng: +drivers[i].lng,
            };
            let desc = {
                text: drivers[i].name + ' [' +  drivers[i].activeOrders + ']',
                color: 'black',
                fontWeight: 'bold',
                fontSize: '14px'
            };
            this.locationMarkers.push({ position: marker, icon: _self.markerOptionsCourier, desc: desc });
        }
    }
}

function visibleDevelop() {
    return localStorage.getItem('sb95') === 'braca'
}

function generateCouriersCount(activeOrders){
    let _self = this;
    let courierMap = new Map()
    var i = 0;
    for(i =0; i < activeOrders.length; i++){
        if(activeOrders[i].courier != null){
            var courierId = activeOrders[i].courier.id;
            if(courierMap.has(courierId)){
                var currentCount = courierMap.get(courierId);
                courierMap.set(courierId, currentCount + 1)
            }else{
                courierMap.set(courierId, 1);
            }
        }
    }
    _self.couriersActiveCount = courierMap;
}


// WEBPACK FOOTER //
// ./src/components/Tracking/Tracking.js